import { useNavigate } from 'react-router-dom'

// project imports
import { Views } from 'features/enumerations'
import useAuth from 'hooks/useAuth'
import { useEffect, useState } from 'react'
import { GuardProps } from 'types'

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const PlayerGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, claims } = useAuth()
  const [render, setRender] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    ;(function checkAuthorization(): any {
      if (isLoggedIn && claims && !claims?.player) {
        navigate(`/${Views.Home}`, { replace: true })
      }
    })()
    ;(function checkAuthorization(): any {
      if (isLoggedIn && claims && !claims?.player) {
        navigate(`/${Views.Home}`, { replace: true })
      }
    })()
    setRender(isLoggedIn && claims?.player)
  }, [isLoggedIn, navigate, claims?.player])

  return children
}

export default PlayerGuard
